export const CORE_PREFILL_STORE = 'CORE_PREFILL_STORE';
